module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Hibiscus.4de32cdf.pdf";